import { render } from "./ReportsIcon.vue?vue&type=template&id=13879b70"
import script from "./ReportsIcon.vue?vue&type=script&lang=js"
export * from "./ReportsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__